import React from "react";
import { Box, Card } from "@mui/material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import UploadSignature from "../../components/SignLayout/components/SignatureUpload";
import SignPad from "../../components/SignLayout/components/SignaturePad";
export function SignLayout(props) {
  const { rhf, control, uid, formikName } = props;

    //tabs
  const [tab, setTab] = React.useState("signImg");
  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Card sx={{ maxWidth: 2045 }}>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={tab}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="อัพโหลดลายเซ็น" value="signImg" />
              <Tab label="ลายเซ็นบนเว็บ" value="signPad" />
            </TabList>
          </Box>
          <TabPanel value="signImg">
            <UploadSignature
              {...props}
              rhf={rhf}
              control={control}
              uid={uid}
              formikName={formikName}
            />
          </TabPanel>
          <TabPanel value="signPad">
            <SignPad
              {...props}
              rhf={rhf}
              control={control}
              uid={uid}
              formikName={formikName}
            />
          </TabPanel>
        </TabContext>
      </Box>
    </Card>
  );
}
